import { Roles } from '@/auth/azure/Roles'
import { createDescriptor } from '@/components/BreadCrumbs/BreadCrumbs'
import ExpenseEditor from '@/routes/expenses/ExpenseEditor'
import { expenseEditorRouteAction, expenseEditorRouteLoader } from '@/routes/expenses/ExpenseEditor.route'
import { RoleRouteObject } from '@/types'

const ExpenseCreatorRoute = {
  path: 'new',
  element: <ExpenseEditor creating={true} />,
  loader: expenseEditorRouteLoader,
  action: expenseEditorRouteAction,
  allowedRoles: [
    Roles.GlobalAdministrator,
    Roles.Administrator,
    Roles.Marketing,
    Roles.TechDeveloper,
    Roles.Sales,
    Roles.Supervisor,
  ],
  handle: {
    crumb: () => createDescriptor,
  },
} as RoleRouteObject

export default ExpenseCreatorRoute
